import { effect, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from './core/user.service';
import { Global } from './core/Global';

@Injectable()

export class ContractService {
	private url: string;
	private entity


	constructor(
		private _http: HttpClient,
		private _userService: UserService,
	) {
		this.url = Global.url_seguros;
		this.entity = this._userService.sharingEntity()

	}
	getActiveContracts(insured: string): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json')
		return this._http.get(this.url + 'contracts/active-contracts/' + insured, { headers: headers })
	}

	getHistoryContracts(insured: string, policy: string): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json')
		return this._http.get(this.url + 'contracts/history-contracts/' + insured + '/' + policy, { headers: headers })
	}

	getByCoverage(coverage: any, month: any): Observable<any> {
		return this._http.get(this.url + `policy-charges/${coverage}/${month}`)
	}

	getByEntity(entity: any, policy: any, month: any): Observable<any> {
		return this._http.get(this.url + `policy-charges/entity/${entity}/${policy}/${month}`)
	}

	getByPolicy(policy: any, month: any): Observable<any> {
		return this._http.get(this.url + `policy-charges/policy/${policy}/${month}`)
	}

	getByPolicyAndCampus(campus: any, policy: any, month: any): Observable<any> {
		return this._http.get(this.url + `policy-charges/campus/${campus}/${policy}/${month}`)
	}

	getUF(month: any): Observable<any> {
		return this._http.get(this.url + `cmf/${month}`)	
	}

}
